import React, { useState, useEffect } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

// const SentimentAnalysis = ({ postCount, commentsCount, counts }) => {
const SentimentAnalysis = ({
  commentsCount,
  counts,
  comments,
  sentimentArray,
}) => {
  const [outerRadius, setOuterRadius] = useState(200);
  const [containerHeight, setContainerHeight] = useState(500);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setOuterRadius(100);
        setContainerHeight(300);
      } else if (width < 1024) {
        setOuterRadius(150);
        setContainerHeight(400);
      } else {
        setOuterRadius(200);
        setContainerHeight(500);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial call to set the values based on the current window size

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const total = counts.negative + counts.neutral + counts.positive;
  const data = [
    { name: "Negative", value: counts.negative },
    { name: "Neutral", value: counts.neutral },
    { name: "Positive", value: counts.positive },
  ];

  const COLORS = ["#EF4444", "#F59E0B", "#10B981"];

  // Add debugging useEffect
  useEffect(() => {
    console.log("Props received in SentimentAnalysis:", {
      commentsCount,
      counts,
      comments,
      sentimentArray,
    });
  }, [commentsCount, counts, comments, sentimentArray]);

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  return (
    <div className="w-full mx-auto">
      <div className="flex flex-col">
        <div className="flex items-center p-4 bg-white rounded-lg shadow-md">
          <div className="w-full">
            <p
              style={{ fontFamily: "Red Hat Display" }}
              className="my-2 text-xl font-bold orange"
            >
              Aggregate Sentiments
            </p>
            <div className="flex">
              <ResponsiveContainer width="70%" height={containerHeight}>
                <PieChart>
                  <Pie
                    data={data}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    outerRadius={outerRadius}
                    fill="#8884d8"
                    dataKey="value"
                  >
                    {data.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                  <Tooltip formatter={(value) => `${value}`} />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
              <div className="content-center space-y-3 text-center">
                <div className="p-4 bg-red-100 rounded">
                  <p className="text-xl font-semibold">Negative</p>
                  <p className="text-xl">
                    {((counts.negative / total) * 100).toFixed(2)}%
                  </p>
                </div>
                <div className="p-4 bg-yellow-100 rounded">
                  <p className="text-xl font-semibold">Neutral</p>
                  <p className="text-xl">
                    {((counts.neutral / total) * 100).toFixed(2)}%
                  </p>
                </div>
                <div className="p-4 bg-green-100 rounded">
                  <p className="text-xl font-semibold">Positive</p>
                  <p className="text-xl">
                    {((counts.positive / total) * 100).toFixed(2)}%
                  </p>
                </div>
                <div className="mt-4">
                  {/* <p className="text-lg font-semibold">Posts: {postCount}</p> */}
                  <p className="text-lg font-semibold">
                    Comments: {commentsCount}
                  </p>
                </div>
              </div>
            </div>

            {/* Sentiment Analysis Table (Contains List of Comments and whether it's positive, negative, or neutral)*/}
            <div className="mt-8">
              <div className="grid grid-cols-2 gap-4 mb-4">
                <div className="p-4 rounded-lg bg-light-orange">
                  <h2 className="text-xl font-bold text-center orange">
                    Comment
                  </h2>
                </div>
                <div className="p-4 bg-red-100 rounded-lg bg-light-orange">
                  <h2 className="text-xl font-bold text-center orange">
                    Sentiment
                  </h2>
                </div>
              </div>

              {/* Table Content */}
              {comments.map((comment, index) => (
                <div key={index} className="grid grid-cols-2 gap-4 mb-4">
                  <div className="flex justify-center items-center p-4 rounded-lg bg-light-orange">
                    <p className="text-lg text-center">{comment}</p>
                  </div>
                  <div className="flex items-center justify-center p-4 rounded-lg bg-light-orange">
                    <p className="text-lg text-center">
                      {capitalizeFirstLetter(sentimentArray[index])}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SentimentAnalysis;
